import Repository from './Repository';
import {empty} from "../../shared/utils";

const resource = 'donation';
const resources = 'donations';

export default {
  get() {
    return Repository.get(resources)
  },
  getDonation(donationId) {
    return Repository.get(resource + '/' + donationId)
  },
  searchDonations(search) {
    let query = '?'

    if (!empty(search.status)) {
      query  += '&status[]=' +search.status
    }

    if (!empty(search.limit)) {
      query += '&limit='+search.limit
    }

    if (!empty(search.campaign)) {
      query += '&campaignIds[]='+search.campaign;
    }

    if (!empty(search.page)) {
      query += '&page='+search.page
    }

    return Repository.get(resources + query)
  },
  createDonation(payload) {
    return Repository.post(resource, payload);
  }
}
